import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popup } from 'semantic-ui-react';

import HelpIcon from 'assets/images/icons/help-icon.svg';
import CalendarIcon from 'assets/images/icons/calendar.svg';
import VisaIcon from 'assets/images/icons/Visa-Light.svg';
import MasterCardIcon from 'assets/images/icons/MasterCard-light.svg';
import CVVIcon from 'assets/images/icons/cvv.svg';

const Wrapper = styled.div`
  margin-bottom: 2rem;

  .input-wrapper {
    display: flex;
    flex-direction: column;
    font-family: Helvetica;
    padding-top: 10px;
    margin-bottom: 1rem;
    border-bottom: 1px solid #35447d;

    .hint {
      font-size: 1.2rem;
      color: ${props => (props.disabled ? '#6c6c6c' : '#35447d')};
      padding-left: 2px;
    }

    .input-field {
      display: flex;
      align-items: center;

      .btn-unsure {
        background: none;
        border: none;
        color: ${props => (props.disabled ? '#6c6c6c' : '#35447d')};
        cursor: pointer;
        font-size: 1.4rem;
        outline: none;
        text-decoration: underline;
      }
      .btn-unsure:hover {
        color: ${props => (props.disabled ? '#6c6c6c' : '#2a3664')};
      }
      .popup { background: red; }
      img {
        height: 2rem;
        width: 2rem;
        margin-left: 3px;
      }
    }
  }
  span {
    color: #35447d;
    font-size: 1.2rem;
  }
`;

const InputWrapper = styled.input`
  font-family: UtopiaStd-Regular;
  color: ${props => (props.disabled ? '#6c6c6c' : '#35447d')};
  font-size: 2rem;
  height: 36px;
  flex: 1;
  outline: none;
  border: none;
  background: transparent;
  margin-top: -5px;
  ::placeholder {
    color: ${props => (props.disabled ? '#6c6c6c' : '#35447d')};
    opacity: 1;
  }
`;

const TextareaWrapper = styled.textarea`
  font-family: UtopiaStd-Regular;
  color: ${props => (props.disabled ? '#6c6c6c' : '#35447d')};
  font-size: 2rem;
  height: ${props => props.height || '56px'};
  flex: 1;
  outline: none;
  border: none;
  background: transparent;
  resize: none;
  ::placeholder {
    color: ${props => (props.disabled ? '#6c6c6c' : '#35447d')};
    opacity: 1;
  }
`;

class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHint: props.value.length > 0,
      value: props.value,
    };
  }

  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e, this.props.name);
    }
    this.setState({ value: e.target.value });
    if (e.target.value.length > 0) {
      if (!this.state.showHint) {
        this.setState({ showHint: true });
      }
    } else {
      this.setState({ showHint: false });
    }
  }

  unsure(e) {
    e.target.value = 'Unsure';
    this.onChange(e);
  }

  render() {
    const {
      hint,
      placeholder,
      isRequired,
      disabled,
      help,
      iconName,
      textarea,
      unsureBtn,
      onChange,
      name,
      error,
      ...rest
    } = this.props;

    const requiredStr = placeholder !== '' && isRequired ? '*' : '';
    let icon;

    switch (iconName) {
      case 'calendar':
        icon = [CalendarIcon];
        break;
      case 'payment':
        icon = [VisaIcon, MasterCardIcon];
        break;
      case 'cvv':
        icon = [CVVIcon];
        break;
      default:
        break;
    }

    return (
      <Wrapper>
        <div className="input-wrapper" disabled={disabled}>
          {this.state.showHint && <span className="hint">{placeholder}{isRequired && '*'}</span>}
          <div className="input-field">
            {textarea
              ? <TextareaWrapper placeholder={`${placeholder}${requiredStr}`} disabled={disabled} value={this.state.value} {...rest} onChange={e => this.onChange(e)} />
              : <InputWrapper placeholder={`${placeholder}${requiredStr}`} disabled={disabled} value={this.state.value} {...rest} onChange={e => this.onChange(e)} />
            }
            {help !== '' &&
              <Popup
                inverted
                trigger={<img alt="help-icon" src={HelpIcon} />}
                position="top center"
                content={help}
              />
            }
            {iconName !== '' &&
              icon.map(i => <img alt="icon" src={i} />)
            }
            {unsureBtn &&
              <button className="btn-unsure" onClick={e => this.unsure(e)}>unsure</button>
            }
          </div>
        </div>
        {error && (
          <span>
            {name === 'email'
              ? 'A valid email is required'
              : 'This field is required and must be less than 255 characters'
            }
          </span>
        )}
      </Wrapper>
    );
  }
}

InputField.propTypes = {
  hint: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  hasPopup: PropTypes.bool,
  disabled: PropTypes.bool,
  help: PropTypes.string,
  iconName: PropTypes.string,
  textarea: PropTypes.bool,
  unsureBtn: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.bool,
};

InputField.defaultProps = {
  hint: '',
  isRequired: false,
  disabled: false,
  placeholder: '',
  hasPopup: false,
  help: '',
  iconName: '',
  textarea: false,
  unsureBtn: false,
  onChange: false,
  name: '',
  value: '',
  error: false,
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField/index.js